import download from 'assets/download.svg'
import downloadImage from 'features/authorized/components/portal/components/qr/common/utils/downloadImage'
import Button from 'features/common/components/Button'
import EmployeeModal from '../common/EmployeeModal'
import {useTranslation} from 'react-i18next'
import Spinner from 'features/common/components/Spinner'
import useEmployeeQR from '../../../../../common/hooks/useEmployeeQR'

interface StaffModalProps {
    employee: {
        qrId: number
        name: string
        role: string
    }
    onClose: () => void
}

const QRModal = ({employee, onClose}: StaffModalProps) => {
    const {t} = useTranslation()
    const {data, isLoading} = useEmployeeQR(employee)
    const isOpen = !!employee

    const onDownload = () => {
        if (!data) {
            return
        }
        downloadImage({data, name: `QR ${employee.name}`})
    }

    return (
        <EmployeeModal isOpen={isOpen} onClose={onClose}>
            <div className="flex w-[42rem] flex-col items-center">
                {data ? (
                    <>
                        <div className="mb-2 text-2xl font-medium">
                            {employee.name}
                        </div>
                        <div className="mb-6 font-medium text-grey-70">
                            {employee.role}
                        </div>
                        <img className="mb-12 w-80" src={data} alt="qr" />
                        <Button
                            onClick={onDownload}
                            className="flex gap-4 rounded-full py-5 px-6"
                        >
                            {t('QR_DOWNLOAD')}
                            <img src={download} alt="download" />
                        </Button>
                    </>
                ) : isLoading ? (
                    <div className="flex w-[42rem] items-center justify-center">
                        <Spinner className="h-20 w-20" yellow />
                    </div>
                ) : (
                    '-'
                )}
            </div>
        </EmployeeModal>
    )
}

export default QRModal
